import { Component, Input } from '@angular/core';
import { Job } from '../../../../../../shared/models/models';

@Component({
	selector: 'invoice-client-info',
	template: require('./invoice-client-info.html'),
	styles: [require('./invoice-client-info.scss')]
})
export class InvoiceClientInfoComponent {
	@Input() job: Job;
	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/invoices/invoice-update/invoice-client-info/invoice-client-info.ts